import * as React from 'react';
import { Socials } from '../Socials';
import { UIHeading1, UIHeading2 } from '@cian/ui-kit';
import * as style from './SharingSocials.css';
import { TSocials } from '../../../common/types/socials';

interface ISharingSocialsProps {
  socialsData: TSocials[];
  isPhone: boolean;
}
export const SharingSocials: React.FC<ISharingSocialsProps> = ({ socialsData, isPhone }) => {
  const Title = isPhone ? UIHeading2 : UIHeading1;

  return (
    <div className={style['container']}>
      <div className={style['title']}>
        <Title>Поделиться в соцсетях</Title>
      </div>
      <div className={style['socials']}>
        <Socials socials={socialsData} />
      </div>
    </div>
  );
};
